import type { ProductsType } from 'redux-store/slices/products/types';

export default function filterProductsByPage(
  products: ProductsType,
  productPage: string,
): ProductsType {
  return products.filter(product => {
    return product.screens.includes(productPage);
  });
}
